import { BaseService } from '../../infra/base.service'
import type { CreateDeviceDto } from './create-device.dto'
import { UAParser } from 'ua-parser-js'
import type { DevicesRepository } from './devices.repository'
import type { DeviceEntity } from './device.entity'
import type { SendPushNotification } from './send-push-notification.dto'

export class DevicesService extends BaseService<DeviceEntity> {
    constructor(private rep: DevicesRepository) {
        super(rep)
    }

    getDeviceId() {
        let deviceId = localStorage.getItem('device_id_for_' + window.store?.company?.companyId)
        return deviceId || null
    }

    async refreshToken() {
        const deviceId = this.getDeviceId()
        const device = await this.rep.refreshToken(deviceId)
    }

    running = false
    async upsertDevice() {
        if (this.running) return
        this.running = true
        await new Promise((resolve) => setTimeout(resolve, 1500))
        try {
            const companyId = window.store.token.companyId
            if (!companyId) return
            let fcmToken = undefined
            if (Notification.permission === 'granted') {
                fcmToken = await window.api.utils.utils.getFcmTokenWithFirebase()
                if (!fcmToken) fcmToken = undefined
            }

            const { browser, cpu, device, os } = UAParser(navigator.userAgent)

            // a ordem do fullVersionList é embaralhada e inclui uma marca falsa
            // ("Not)A;Brand" 24.0.0.0), então a marca é escolhida pelo nome do navegador
            let fullVersion = null
            try {
                if (navigator['userAgentData'] && browser?.name) {
                    const _version = await navigator['userAgentData'].getHighEntropyValues(['fullVersionList'])
                    const name = browser.name.replace(/^mobile\s+/i, '').toLowerCase()
                    const brand = _version?.fullVersionList?.find((el) => el?.brand?.toLowerCase().includes(name))
                    fullVersion = brand?.version || null
                }
            } catch (error) {}
            let description = ''
            if (device?.vendor) {
                description = device.vendor + ' ' + device.model
            }
            if (os?.name) {
                if (description) description += ' - '
                description += os.name + ' ' + os.version
            }
            if (description && cpu?.architecture) {
                description += ' (' + cpu.architecture + ')'
            }
            if (browser?.name) {
                if (description) description += ' - '
                description += browser.name + ' ' + (fullVersion || browser.version)
            }
            if (await window.api.utils.utils.isInstalled()) {
                if (description) description += ' (aplicativo)'
            }

            if (!description) description = undefined

            const dto: CreateDeviceDto = {
                fcmToken,
                label: undefined,
                description,
            }

            let deviceId = localStorage.getItem('device_id_for_' + companyId)
            if (deviceId) {
                try {
                    await this.update(deviceId, dto)
                    return deviceId
                } catch (error) {
                    // se o device não existe mais (ex. foi excluído)
                    console.log('Device update error:', error)
                    if (!error?.includes('not found')) return
                }
            }

            const newDevice: DeviceEntity = await this.create(dto)
            if (!newDevice) {
                return null
            }
            localStorage.setItem('device_id_for_' + companyId, newDevice.deviceId)
        } catch (error) {
            window.log('[devices.service.ts] Error in upsertDeviceId', 'error', error)
            return null
        } finally {
            this.running = false
        }
    }

    async requestLoginByDevice() {
        const deviceId = this.getDeviceId()
        if (!deviceId) return null
        return await this.rep.requestLoginByDevice(deviceId)
    }

    async requestJWTTokenByDevice() {
        // solicita login pelo device, que possui o cookie já armazenado
        // e retorna o token JWT
        const companyId = window.store?.company?.companyId
        if (!companyId) return null
        return await this.rep.requestJWTTokenByDevice(companyId)
    }

    async sendPushNotification(dto: SendPushNotification) {
        return await this.rep.sendPushNotification(dto)
    }
}
